import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useState } from "react";
import globalRiskImg from "../../assets/images/globalRiskImg.webp";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import MockDialogBox from "./MockDialogBox";
import MockGlobalRiskCompanyModal from "./MockGlobalRiskCompanyModal";
import MockGlobalRiskLocationModal from "./MockGlobalRiskLocationModal";
import MockGlobalRiskReportModal from "./MockGlobalRiskReportModal";
import MockMapComponent from "./MockMapComponent";
import { MockGlobalRisks } from "./mockModalData";
import MockSideBar from "./MockSideBar";
import { getProgress, updateUserJourneyState } from "./mockUtils";
import { useHistory } from "react-router-dom";

const MockIntelligence = () => {
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const [openReportModal, setOpenReportModal] = useState(false);
  const [openCompanyModal, setOpenCompanyModal] = useState(false);
  const [openLocationRiskModal, setOpenLocationRiskModal] = useState(false);
  const [openFreeTrialModal, setOpenFreeTrialModal] = useState(false);

  const makeApiCall = () => {
    (async () => {
      try {
        userContext.setUserJourneyInfo(
          updateUserJourneyState(userContext.userJourneyInfo)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const handleCatchUpTooltipRisk = (open) => {
    setOpen(false);
    setOpenReportModal(true);
    makeApiCall();
  }

  return (
    <>
      <MockDialogBox
        mockModalData={MockGlobalRisks}
        image={globalRiskImg}
        stepTitle={MockGlobalRisks.title}
        callback={() => {
          setOpen(true);
        }}
      />
      <div className={classes.root}>
       <MockSideBar handleTooltip = {handleCatchUpTooltipRisk} open={open}/>
        {openReportModal && (
          <MockGlobalRiskReportModal
            onCallBack={() => {
              setOpenReportModal(false);
              setOpenCompanyModal(true);
              makeApiCall();
            }}
          />
        )}
        {openCompanyModal && (
          <MockGlobalRiskCompanyModal
            onCallBack={() => {
              setOpenCompanyModal(false);
              setOpenLocationRiskModal(true);
              makeApiCall();
            }}
          />
        )}
        {openLocationRiskModal && (
          <MockGlobalRiskLocationModal
            onCallBack={() => {
              setOpenLocationRiskModal(false);
              setOpenFreeTrialModal(true);
              history.push("/kavida/tour/milestone-tracker");
              makeApiCall();
            }}
          />
        )}

        <MockMapComponent />
      </div>
    </>
  );
};

export default MockIntelligence;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    paddingLeft: '-16px',
    flexDirection: "column",
  },
}));
